import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { CancelSubscriptionResponse } from './types';

type CancelMemberSubscriptionParams = {
  memberId: string;
  subscriptionId: string;
  endAccessNow: boolean;
};

export async function cancelMemberSubscription({
  memberId,
  subscriptionId,
  endAccessNow,
}: CancelMemberSubscriptionParams) {
  const url = `/web/studio/users/${memberId}/products-subscriptions/${subscriptionId}/cancel`;

  const response = await api.executePostRequest<ObjectResponse<CancelSubscriptionResponse>>(
    url,
    {},
    {
      params: {
        end_access_now: endAccessNow ? 'true' : 'false',
      },
    }
  );

  return response.data;
}
